/** The file was automatically generated. Please do not modify manually */
import nl from './online.json';
export var strings_nl = nl;
